import { cn } from "@/lib/utils";

export function AwardIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-11.5 w-7.5", className)}
      fill="none"
      viewBox="0 0 30 46"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.6531 0.30875C29.5278 0.118745 29.3126 0.00390625 29.0817 0.00390625H18.7799C18.5121 0.00390625 18.2691 0.157974 18.1592 0.397347L14.3587 8.67927C14.2789 8.85335 14.2789 9.0526 14.3587 9.22669L17.7228 16.5577C17.8327 16.7971 18.0756 16.9511 18.3434 16.9511H21.917C22.1848 16.9511 22.4278 16.7972 22.5377 16.5577L29.7023 0.944767C29.7971 0.738306 29.7785 0.498843 29.6531 0.30875Z"
        fill="#d62d2d"
      />
      <path
        d="M15.8312 5.4707L14.3587 8.67952C14.2789 8.8536 14.2789 9.05286 14.3587 9.22694L17.7228 16.5579C17.8327 16.7973 18.0756 16.9514 18.3434 16.9514H21.0995L15.8312 5.4707Z"
        fill="#9e1219"
      />
      <path
        clipRule="evenodd"
        d="M12.4033 18.1471C12.4033 19.5421 13.561 20.6769 14.9839 20.6769C16.4068 20.6769 17.5646 19.5421 17.5646 18.1471C17.5646 16.7521 16.4069 15.6172 14.9839 15.6172C13.561 15.6172 12.4033 16.7521 12.4033 18.1471ZM13.7679 18.1472C13.7679 17.4879 14.315 16.9516 14.9874 16.9516C15.6599 16.9516 16.207 17.4879 16.207 18.1472C16.207 18.8064 15.6599 19.3427 14.9874 19.3427C14.315 19.3427 13.7679 18.8064 13.7679 18.1472Z"
        fill="#ffa035"
        fillRule="evenodd"
      />
      <path
        d="M18.9678 16.0103L11.8032 0.397347C11.6933 0.157974 11.4503 0.00390625 11.1825 0.00390625H0.880758C0.649828 0.00390625 0.434685 0.118745 0.309284 0.30875C0.183883 0.498843 0.165372 0.738306 0.260103 0.944767L7.42477 16.5577C7.53465 16.7971 7.77756 16.9511 8.04542 16.9511H18.3472C18.5781 16.9511 18.7933 16.8364 18.9187 16.6463C19.0439 16.4561 19.0625 16.2166 18.9678 16.0103Z"
        fill="#ff3d43"
      />
      <path
        d="M16.2007 16.9511H18.3445C18.5754 16.9511 18.7906 16.8364 18.916 16.6463C19.0414 16.4562 19.0599 16.2167 18.9652 16.0103L11.8006 0.397347C11.6907 0.157974 11.4477 0.00390625 11.1799 0.00390625H8.42383L16.2007 16.9511Z"
        fill="#d72e2e"
      />
      <path
        d="M15.0005 19.3418C7.68986 19.3418 1.74219 25.1724 1.74219 32.3392C1.74219 39.506 7.68986 45.3366 15.0005 45.3366C22.3112 45.3366 28.2589 39.506 28.2589 32.3392C28.2589 25.1724 22.3112 19.3418 15.0005 19.3418Z"
        fill="#ffc850"
      />
      <path
        d="M15.0034 19.3418C14.4673 19.3418 13.9386 19.374 13.4189 19.435C19.9853 20.2052 25.0928 25.6981 25.0928 32.3393C25.0928 38.9806 19.9853 44.4734 13.4189 45.2436C13.9387 45.3045 14.4673 45.3367 15.0034 45.3367C22.3141 45.3367 28.2618 39.5061 28.2618 32.3393C28.2618 25.1724 22.3141 19.3418 15.0034 19.3418Z"
        fill="#f4b70c"
      />
      <path
        d="M15.0016 22.9141C9.70052 22.9141 5.3877 27.1419 5.3877 32.3388C5.3877 37.5356 9.70043 41.7635 15.0016 41.7635C20.3027 41.7635 24.6155 37.5356 24.6155 32.3388C24.6155 27.1419 20.3027 22.9141 15.0016 22.9141Z"
        fill="#fff5cf"
      />
      <path
        d="M15.0021 22.9141C14.4956 22.9141 13.9982 22.9529 13.5127 23.0273C18.109 23.7311 21.6371 27.6385 21.6371 32.3388C21.6371 37.0391 18.109 40.9464 13.5127 41.6502C13.9982 41.7246 14.4957 41.7635 15.0021 41.7635C20.3032 41.7635 24.616 37.5356 24.616 32.3388C24.616 27.1419 20.3032 22.9141 15.0021 22.9141Z"
        fill="#ffeca1"
      />
      <path
        d="M20.4537 32.0112C20.8753 31.6084 21.024 31.0173 20.8422 30.4685C20.6603 29.9197 20.1855 29.5273 19.603 29.4443L17.4652 29.1397C17.4085 29.1317 17.3596 29.0967 17.3343 29.0464L16.3783 27.1475C16.1178 26.6301 15.5903 26.3086 15.0018 26.3086C15.0017 26.3086 15.0018 26.3086 15.0017 26.3086C14.4131 26.3086 13.8856 26.6301 13.6251 27.1475L12.6691 29.0465C12.6437 29.0968 12.5948 29.1317 12.5381 29.1398L10.4005 29.4443C9.81795 29.5273 9.3432 29.9197 9.16127 30.4685C8.97934 31.0173 9.12815 31.6083 9.54972 32.0112L11.0966 33.4894C11.1376 33.5286 11.1563 33.585 11.1465 33.6404L10.7814 35.7274C10.6819 36.2961 10.9159 36.8602 11.3921 37.1993C11.6612 37.391 11.976 37.4883 12.2929 37.4883C12.5369 37.4883 12.7822 37.4306 13.0088 37.3139L14.9207 36.3285C14.9715 36.3023 15.032 36.3023 15.0826 36.3285L16.9946 37.3139C17.5155 37.5824 18.135 37.5385 18.6112 37.1993C19.0874 36.8602 19.3214 36.2962 19.2219 35.7274L18.8567 33.6403C18.8471 33.585 18.8658 33.5286 18.9068 33.4894L20.4537 32.0112Z"
        fill="#ffa035"
      />
      <path
        d="M20.4535 32.0093C20.8751 31.6066 21.0238 31.0155 20.842 30.4666C20.66 29.9179 20.1853 29.5254 19.6027 29.4424L19.4996 29.4277L16.3801 32.3689C16.1787 32.5614 16.0868 32.8387 16.1344 33.1104L16.852 37.2386L16.9945 37.312C17.5155 37.5805 18.1349 37.5366 18.6111 37.1975C19.0873 36.8583 19.3214 36.2943 19.2218 35.7255L18.8567 33.6384C18.8471 33.5831 18.8658 33.5267 18.9068 33.4875L20.4535 32.0093Z"
        fill="#f78819"
      />
      <path
        d="M23.9193 16.9515H6.05261C5.67677 16.9515 5.37207 16.6528 5.37207 16.2843C5.37207 15.9159 5.67677 15.6172 6.05261 15.6172H23.9193C24.2952 15.6172 24.5999 15.9159 24.5999 16.2843C24.5999 16.6528 24.2952 16.9515 23.9193 16.9515Z"
        fill="#ffc850"
      />
    </svg>
  );
}
